import React from 'react'
import { Routes, Route, Navigate } from 'react-router-dom'
import { Layout } from 'antd'

import { useAuth } from '@hooks/useAuth'
import LoginPage from '@pages/Login'
import DashboardLayout from '@components/Layout/DashboardLayout'
import Dashboard from '@pages/Dashboard'
import SubscriptionManagement from '@pages/SubscriptionManagement'
import SubscriptionDetailPage from '@pages/SubscriptionDetail'
import UserManagement from '@pages/UserManagement'
import UserDetailPage from '@pages/UserDetailPage'
import GardenManagement from '@pages/GardenManagement'
import GardenEdit from '@pages/GardenEdit'
import GardenDetail from '@pages/GardenDetail'
import DeliveryManagement from '@pages/DeliveryManagement'
import Statistics from '@pages/Statistics'
import SystemSettings from '@pages/SystemSettings'
import AdminAccountsPage from '@pages/AdminAccounts'
import FeedbackManagement from '@pages/FeedbackManagement'

const App: React.FC = () => {
  const { isAuthenticated, loading } = useAuth()

  console.log('App: 渲染状态 - isAuthenticated:', isAuthenticated, 'loading:', loading)

  if (loading) {
    console.log('App: 显示加载状态')
    return (
      <Layout style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <div>加载中...</div>
      </Layout>
    )
  }

  if (!isAuthenticated) {
    console.log('App: 未认证，显示登录页面')
    return (
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        <Route path="*" element={<Navigate to="/login" replace />} />
      </Routes>
    )
  }

  console.log('App: 已认证，显示管理界面')

  return (
    <DashboardLayout>
      <Routes>
        <Route path="/" element={<Navigate to="/dashboard" replace />} />
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/subscriptions" element={<SubscriptionManagement />} />
        <Route path="/subscriptions/:id" element={<SubscriptionDetailPage />} />
        <Route path="/users" element={<UserManagement />} />
        <Route path="/users/:id" element={<UserDetailPage />} />
        <Route path="/gardens" element={<GardenManagement />} />
        <Route path="/gardens/create" element={<GardenEdit />} />
        <Route path="/gardens/edit/:id" element={<GardenEdit />} />
        <Route path="/gardens/:id" element={<GardenDetail />} />
        <Route path="/delivery" element={<DeliveryManagement />} />
        <Route path="/statistics" element={<Statistics />} />
        <Route path="/admin-accounts" element={<AdminAccountsPage />} />
        <Route path="/settings" element={<SystemSettings />} />
        <Route path="/feedback" element={<FeedbackManagement />} />
        <Route path="*" element={<Navigate to="/dashboard" replace />} />
      </Routes>
    </DashboardLayout>
  )
}

export default App
